/**
 * @class
 * @description class being used for each single additional chart item
 * @param {Node} args.element the outer element of this item
 * @param {Object} args.data the JSON data of this item
 * @param {Object} args.translations text translations object
 */
export default class AdditionalChart {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;
    this.measurement = args.measurement;
    this.user = args.user;
    this.env = args.env;
    this.translations = args.translations;
    this.getPriceDevelopmentIndicator = args.getPriceDevelopmentIndicator;

    this.render();
  }

  render() {
    this.element.classList.add('item');
    this.element.innerHTML = this.template;
  }

  get template() {
    return `
      <a href="/news/chart/details/${this.data.stockmarket_index_id}" class="item-inner" title="${this.translations.goToDetails}">
        <div class="item-image">
          <img alt="" src="${this.data.image_path}" alt="${this.data.fullname || '{{fullname}}'}">

          ${this.data.is_bio ? `
            <div class="bio-icon inline">
              <i class="fas fa-leaf"></i>
              <span>${this.translations.bio}</span>
            </div>
          `: ``}
        </div>
        <div class="item-content">
          <div class="item-title">${this.data.fullname}</div>
          <div class="item-category">${this.data.sub_categoryname}</div>
          <div class="item-details">
            <div class="item-price">
              <b>${this.translations.price}:</b>
              <span>
                ${new Intl.NumberFormat(this.env.locale, {
                  style: 'currency',
                  currency: this.data.currency_code,
                  minimumFractionDigits: 3
                }).format(this.data.latest_price)}/${this.measurement}
              </span>
              ${this.getPriceDevelopmentIndicator(this.data)}
            </div>
            <div class="item-country">
              <b>${this.translations.origin}:</b>
              <img class="flag-icon" src="/projects/application/dist/images/icons/flags/4x3/${this.data.country_short.toLowerCase()}.svg" alt="" title="${this.data.country_name}">
              <span>${this.data.country_name}</span>
            </div>
            <div class="item-freight-terms">
              <b>${this.translations.incoType}:</b>
              ${this.data.freight_term} (${this.data.country_name})<br>
            </div>
            <div class="item-location">
              <b>${this.translations.location}:</b>
              ${this.data.location}
            </div>
          </div>
        </div>
      </a>
    `;
  }
}